
import { useState, useEffect } from "react";
import axios from "axios";
import styled from "styled-components";
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select';
import Swal from "sweetalert2";
import { toast } from 'react-toastify';

import BlueButton from "../../../../ui/BlueButton";
import OrangeButton from "../../../../ui/OrangeButton";
import RedButton from "../../../../ui/RedButton";

const DivGeral = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: #fff;
  padding: 25px;
  box-shadow: 0px 0px 2px #ccc;
`;


const Label = styled.label`
  color: #4f4f4f;
  font-weight: 600;
  font-size: 17px;  
  display: flex;
  flex-direction: column;

  select {
    &.erro {
      border: 2px solid red;
      
    }
  }
`;






const Div = styled.div`
  display: flex;
  flex-direction:row;
  justify-content: center;
  gap: 1rem;
  margin-top: 1rem;

  select {
    width: 250px;
    padding: 0 10px;
    border: 1px solid #bbb;
    border-radius: 5px;
    height: 37px;
  }

`;

const Input = styled.input`

  width: 300px;
  padding: 0 10px; /* Adiciona 10px de padding horizontal */
  border: 1px solid #bbb;
  border-radius: 5px;
  height: 37px;
  box-sizing: border-box; 

    &.erro {
    border: 2px solid red;
    
  }
`;

const Input1 = styled.input`

  width: 250px;
  padding: 0 10px; /* Adiciona 10px de padding horizontal */
  border: 1px solid #bbb;
  border-radius: 5px;
  height: 37px;
  box-sizing: border-box; 

  &.erro {
    border: 2px solid red;
    
  }
`;


const Input2 = styled.input`
  width: auto;
  min-width: 300px;
  padding: 0 10px; /* Adiciona 10px de padding horizontal */
  border: 1px solid #bbb;
  border-radius: 5px;
  height: 37px;
  box-sizing: border-box; /* Garante que padding não aumente o tamanho total */
`;


const Input5 = styled.input`
  width: auto;
  min-width: 620px;
  height: 200px;
  padding: 0 10px; /* Adiciona 10px de padding horizontal */
  border: 1px solid #bbb;
  border-radius: 5px;
  height: 37px;
  box-sizing: border-box; /
  &.erro {
      border: 2px solid red;
      
    }
`;

const H2 = styled.h2`
  color: #575757;
`;



const SelectContainer = styled.div`
  .custom-select__control {
    border-radius: 6px;
    padding: 2px 0px;
    height: 35px;
    width: 620px;
    box-shadow: none;
    font-weight: normal;
    &:hover {
      border-color: #888;
    }
    &.erro {
      border: 2px solid red;
    
    }
  }

  .custom-select__menu {
    z-index: 9999; /* Isso garante que fique acima do modal */
  }

  .custom-select__menu-list {
    max-height: 120px; /* ~3 itens */
    overflow-y: auto;
  }

  .custom-select__option {
    padding: 2px 0px;
    color: #575757;
    background-color: #fff;
    font-weight: normal;
  }

  .custom-select__placeholder {
    color: #999;
    font-weight: normal;
  }

  .custom-select__single-value {
    color: #000;
    font-weight: normal;
  }

  .custom-select__control.erro {
    border: 2px solid red;
  }


`;



const Form = ({ urlApi, tipoPosse, tipoEquipamento, usuarioEquipamento, editarEquipamentos, setIsModalOpenVerEquipamento, setIsModalOpenEditarEquipamentos, setAtualizaMateriais }) => {
  //========================================================TOKEN
  const token = localStorage.getItem('token');



  const [posseSelecionada, setPosseSelecionada] = useState("");
  const [equipamentoSelecionado, setEquipamentoSelecionado] = useState("");
  const [equipamentoAd, setEquipamentoAd] = useState("");
  const [setorEquipamentoSelecionado, setSetorEquipamentoSelecionado] = useState("");
  const [tagEquipamentoSelecionado, setTagEquipamentoSelecionado] = useState("");
  const [marcaModeloEquipamentoSelecionado, setMarcaModeloEquipamentoSelecionado] = useState("");
  const [serieEquipamentoSelecionado, setSerieEquipamentoSelecionado] = useState("");
  const [usuarioEquipamentoSelecionado, setUsuarioEquipamentoSelecionado] = useState(editarEquipamentos.COD_USUARIO_RESPONSAVEL);
  const [dadosUsuarioSelecionado, setDadosUsuarioSelecionado] = useState(null);
  const [numeroContrato, setNumeroContrato] = useState("");
  const [observacao, setObservacao] = useState("");


  useEffect(() => {
    if (editarEquipamentos && typeof editarEquipamentos === 'object') {
      const equip = editarEquipamentos;

      setPosseSelecionada(equip.ID_TIPO_POSSE?.toString() || "");
      setEquipamentoSelecionado(equip.ID_TIPO_EQUIPAMENTO?.toString() || "");
      setEquipamentoAd(equip.AD?.toString() || "");
      setSetorEquipamentoSelecionado(equip.COD_DEPARTAMENTO?.toString() || "");
      setTagEquipamentoSelecionado(equip.TAG_EQUIPAMENTO || "");
      setMarcaModeloEquipamentoSelecionado(equip.DESC_MARCA_MODELO || "");
      setSerieEquipamentoSelecionado(equip.NUMERO_SERIE || "");
      setUsuarioEquipamentoSelecionado(equip.COD_USUARIO_RESPONSAVEL?.toString() || "");
      setNumeroContrato(equip.CONTRATO || "");
      setObservacao(equip.OBSERVACAO || "");
      setSituacao(equip.SITUACAO || "");

      // Preenche os dados do usuário selecionado também
      const usuarioSelecionado = usuarioEquipamento.find(
        (u) => u.Cod_Func?.toString() === equip.COD_USUARIO_RESPONSAVEL?.toString()
      );
      setDadosUsuarioSelecionado(usuarioSelecionado || null);
    }
  }, [editarEquipamentos, usuarioEquipamento]);




  //Controla as opções do SITUAÇÂO
  const opcoesSituacao = {
    US: "Em uso",
    MA: "Manutenção",
    BA: "Baixado",
    DISP: "Disponível",
    RES: "Reservado",
    TRANS: "Em transferência",
    INST: "Em instalação/configuração",
    DESC: "Descartado / Obsoleto",
    ROUB: "Roubado / Furtado",
  };
  const [situacao, setSituacao] = useState("");

  //Usuários do SELECT
  const opcoesUsuarios = usuarioEquipamento.map((tipo) => ({
    value: tipo.Cod_Func,
    label: `${tipo.Cod_Func} - ${tipo.Desc_Func} - ${tipo.Desc_Departamento}`,
  }));





  const handleEditaEquipamento = () => {
    setIsModalOpenVerEquipamento(false);
    setIsModalOpenEditarEquipamentos(true);
  };


  //---------------------------------------FUNÇÂO DELETAR EQUIPAMENTO---------------------------------------------------//


  //PopUp de confirmação
  const showPopUp = () => {
    return new Promise((resolve) => {
      Swal.fire({
        title: "Essa ação irá apagar todos os dados sobre o equipamento e os chamados referentes a esse equipamento, deseja confirma?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        customClass: {
          container: 'custom-swal-container',
        },
      }).then((result) => {
        resolve(result.value); // Resolve a Promise com o valor result.value
      });
    });
  };


  // Deleta os usuários
  const handleDelete = async () => {
    const userConfirmed = await showPopUp();

    if (!userConfirmed) {
      return;
    }

    try {
      // Tenta realizar a requisição para deletar o usuário
      await axios.delete(`${urlApi}central-ti/deletar-equipamento/${editarEquipamentos.TAG_EQUIPAMENTO}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      toast.success("Equipamento deletado com sucesso.");
      setAtualizaMateriais(true);
      setIsModalOpenVerEquipamento(false);

    } catch (error) {

      toast.error(error);


    }


  };


  //---------------------------------------FUNÇÂO DESATIVAR EQUIPAMENTO---------------------------------------------------//


  //PopUp de confirmação
  const showPopUp2 = () => {
    return new Promise((resolve) => {
      Swal.fire({
        title: "Essa ação irá desativar o equipamento, impossibilitando a abertura de chamados para o mesmo, deseja confirma?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        customClass: {
          container: 'custom-swal-container',
        },
      }).then((result) => {
        resolve(result.value); // Resolve a Promise com o valor result.value
      });
    });
  };


  // Deleta os usuários
  const handleDesativar = async () => {
    const userConfirmed = await showPopUp2();

    if (!userConfirmed) return;

    try {
      await axios.put(
        `${urlApi}central-ti/desativar-equipamento/${editarEquipamentos.TAG_EQUIPAMENTO}`,
        {}, // corpo vazio
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      toast.success("Equipamento desativado com sucesso.");
      setAtualizaMateriais(true);
      setIsModalOpenVerEquipamento(false);
    } catch (error) {
      console.error(error);
      toast.error("Erro ao desativar equipamento.");
    }
  };



  return (
    <DivGeral>
      <H2>Ver o Equipamento</H2>


      <Div>
        <Label>
          Tag do Equipamento:
          <Input1

            type="text"
            value={tagEquipamentoSelecionado}
            onChange={(e) => setTagEquipamentoSelecionado(e.target.value)}
            disabled
          />
        </Label>

        <Label>
          Marca/Modelo:
          <Input2
            type="text"
            value={marcaModeloEquipamentoSelecionado}
            onChange={(e) => setMarcaModeloEquipamentoSelecionado(e.target.value)}
            disabled
          />
        </Label>

        <Label>
          N° de série:
          <Input1
            type="text"
            value={serieEquipamentoSelecionado}
            onChange={(e) => setSerieEquipamentoSelecionado(e.target.value)}
            disabled
          />
        </Label>


      </Div>

      <Div >
        <Label>
          Tipo de Equipamento:
          <select
            disabled
            value={equipamentoSelecionado}
            onChange={(e) => setEquipamentoSelecionado(e.target.value)}
          >
            <option value="" disabled>Selecione o tipo</option>
            {tipoEquipamento.map((tipo) => (
              <option key={tipo.ID_TIPO} value={tipo.ID_TIPO}>
                {tipo.DESC_TIPO_EQUIPAMENTO}
              </option>
            ))}
          </select>
        </Label>
        {(equipamentoSelecionado === "1" || equipamentoSelecionado === "2") && (
          <Label>
            Active Directory:
            <select
              value={equipamentoAd}
              onChange={(e) => setEquipamentoAd(e.target.value)}
              disabled
            >
              <option value="" disabled>Selecione</option>
              <option value="S">Sim</option>
              <option value="N">Não</option>
            </select>
          </Label>
        )}
        <Label>
          Situação:
          <select
            name="situacao"
            disabled
            value={situacao}
            onChange={(e) => setSituacao(e.target.value)}
          >
            {Object.entries(opcoesSituacao).map(([valor, label]) => (
              <option key={valor} value={valor}>{label}</option>
            ))}
          </select>
        </Label>
      </Div>

      <Div >

        <Label>
          Tipo de Posse:
          <select
            disabled
            value={posseSelecionada}
            onChange={(e) => setPosseSelecionada(e.target.value)}
          >
            {tipoPosse.map((tipo) => (
              <option key={tipo.ID_TIPO} value={tipo.ID_TIPO}>
                {tipo.DESC_TIPO_POSSE}
              </option>
            ))}
          </select>
        </Label>

        <Label>
          N° do contrato:
          <Input1
            type="text"
            value={numeroContrato}
            disabled
            onChange={(e) => setNumeroContrato(e.target.value)}
          />
        </Label>



      </Div>

      <Div>
        <Label>
          Usuário Responsável:
          <SelectContainer>
            <Select
              classNamePrefix="custom-select"
              disabled

              value={opcoesUsuarios.find(opt => opt.value === usuarioEquipamentoSelecionado)}
              onChange={(selected) => {
                const codFunc = selected?.value || '';
                setUsuarioEquipamentoSelecionado(codFunc);

                const usuarioSelecionado = usuarioEquipamento.find(u => u.Cod_Func === codFunc);
                setDadosUsuarioSelecionado(usuarioSelecionado || null);
              }}

            />


          </SelectContainer>


        </Label>

      </Div>

      <Div>

        <Label>
          Departamento
          <Input
            type="text"
            value={dadosUsuarioSelecionado?.Desc_Departamento || ''}
            readOnly
            disabled
          />
        </Label>
        <Label>
          Objeto de Custo
          <Input
            type="text"
            value={dadosUsuarioSelecionado?.Desc_ObjetoCusto || ''}
            readOnly
            disabled
          />
        </Label>


      </Div>

      <Div>


        <Label>
          Observação:
          <Input5
            type="text"
            disabled
            value={observacao}
            onChange={(e) => setObservacao(e.target.value)}
          />


        </Label>
      </Div>


      <Div>
        <BlueButton onClick={handleEditaEquipamento}>
          Editar
        </BlueButton>
        <OrangeButton onClick={handleDesativar}>
          Desativar
        </OrangeButton>
        <RedButton onClick={handleDelete}>
          Deletar
        </RedButton>
      </Div>

      <style jsx global>{`
        .swal2-container.custom-swal-container {
          z-index: 9999;
        }
      `}</style>
    </DivGeral >
  );
};

export default Form;




